import { createStore } from '@stencil/store';

import { VehicleConfig } from '../interfaces/interface.vehicle';
import { baseVehicleState } from '../utils/utils.vehicle';

type VehicleConfigState = typeof initialState;

// store used for keeping vehicle config component state.
const initialState: VehicleConfig = {
  ...baseVehicleState,
  availColors: [],
  availEngines: [],
  availDrivetrains: [],
  availTransmissions: [],
  availOptions: [],
  bodyStyle: '',
  changedOptions: [],
  fullVehicleName: '',
  featuredEngine: '',
  featuredDrivetrain: '',
  featuredTransmission: '',
  featuredTransmissionIs4WD: false,
  featuredColor: '',
  featuredColorHex: '',
  featuredOptions: [],
  excludedTransmissions: [],
  excludedEngines: [],
  excludedDrivetrains: [],
  ineligibleTed: '',
};

const { on, onChange, state, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset, VehicleConfigState };
export default state;
